import FastSearch from './FastSearch.vue'

export default FastSearch
